/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_sini } from "../../App/actions/sini_v2";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

class SINI_POINT_CONFIG extends Component {
  state = {};

  on_change = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.props.set_value_sini({
      key: name,
      value: value,
    });
  };

  on_toggle = (e) => {
    const name = e.target.name;
    this.props.set_value_sini({
      key: name,
      value: !this.props.sini[name],
    });
  };

  renderScale = (min, max, step) => {
    const scaleNumbers = [];
    for (let i = min; i <= max; i += step) {
      let number = i;
      if (!Number.isInteger(i)) {
        number = i.toFixed(1);
      }
      scaleNumbers.push(number);
    }
    return (
      <div className="scale_range">
        {scaleNumbers.map((number) => (
          <span key={number} className="scale_range_number">
            {number}
          </span>
        ))}
      </div>
    );
  };

  render() {
    //local storage

    //local state

    //global props
    const { sini_circle_radius } = this.props.sini;

    //content

    return (
      <main>
        <section className="margin_bottom">
          <p className="text_small">
            sini_circle_radius ({sini_circle_radius})
          </p>
          <input
            name="sini_circle_radius"
            value={sini_circle_radius}
            onChange={this.on_change}
            min="0"
            max="5"
            step="0.01"
            type="range"
            data-mapid="sliderRadiusCircle"
          />
          {this.renderScale(0, 20, 1)}
        </section>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  sini: state.sini,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, { set_value_sini })(SINI_POINT_CONFIG);
